import { useHttpClient } from "@/common/api/httpClient";
import type { LogSorterResponse } from "./common/logSorterResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";

export interface GetLogSorterByIdRequest {
  logSorterId: number;
}

export interface GetLogSorterByIdSuccessResponse {
  ok: true;
  logSorter: LogSorterResponse;
}

export function useGetLogSorterById() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: GetLogSorterByIdRequest) {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`logsorter/${action.logSorterId}`), {
      headers,
      method: 'get'
    });

    const text = translations.value.logSorter.actions.fetch;

    const response = await httpClient.action<GetLogSorterByIdSuccessResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as LogSorterResponse;

        return {
          ok: true,
          logSorter: json
        };
      },
    });

    return response;
  }
}
